export default __webpack_public_path__ + "static/footerCertificateImg-e25a2e6021f5f6e0dc0b1b892a276315.png";